import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './plugins/vant.js'
import './plugins/filter.js'
import router from './router'
import i18n from './i18n/index'
import './permission'
import '@/assets/style/iconfont.css'
import 'tootik/css/tootik.min.css'
import Utils from '@/utils/util'
import 'vant/lib/icon/local.css';//引用字体css
import VueNumeric from '@/components/vue-numeric-currency'
Vue.component('vue-numeric', VueNumeric)
//移动端适配
import 'amfe-flexible';
// 引入全局样式
import '@/assets/css/index.scss'

Vue.config.productionTip = false
Vue.prototype.wConfig =  Utils.getConfig()
Vue.prototype.$utils = Utils
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

